import React from "react";
import { IMaskInput } from "react-imask";

const PhoneMaskInput = React.forwardRef(function PhoneMaskInput(props, ref) {
  const { name, onChange, ...rest } = props;
  return (
    <IMaskInput
      {...rest}
      type="tel"
      name={name}
      placeholder="(000) 000-0000"
      mask="(000) 000-0000"
      inputRef={ref}
      onAccept={(value) => onChange?.({ target: { name, value } })}
      overwrite="shift"
    />
  );
});

export default PhoneMaskInput;
